var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { localized, msg } from '@lit/localize';
import { CommonActions } from '../../../localization/helpers.js';
import '../../icon/Icon.js';
let NetworkToolbox = class NetworkToolbox extends LitElement {
    constructor() {
        super();
        this.listNetworks = [];
    }
    handleNetworkChange(event) {
        const selectedNetworkId = Number(event.detail.value);
        this.selectedNetwork = this.listNetworks.find((n) => n.network_id === selectedNetworkId);
        this.dispatchEvent(new CustomEvent('network-change', {
            detail: { selectedNetwork: this.selectedNetwork },
            bubbles: true,
            composed: true,
        }));
    }
    handleRenameNetwork() {
        this.dispatchEvent(new CustomEvent('rename-network', {
            detail: { selectedNetwork: this.selectedNetwork },
            bubbles: true,
            composed: true,
        }));
    }
    handleDuplicateNetwork() {
        this.dispatchEvent(new CustomEvent('duplicate-network', {
            detail: { selectedNetwork: this.selectedNetwork },
            bubbles: true,
            composed: true,
        }));
    }
    handleUpdateNetwork() {
        this.dispatchEvent(new CustomEvent('update-network', {
            detail: { selectedNetwork: this.selectedNetwork },
            bubbles: true,
            composed: true,
        }));
    }
    handleExportNetwork() {
        this.dispatchEvent(new CustomEvent('export-network', {
            detail: { selectedNetwork: this.selectedNetwork },
            bubbles: true,
            composed: true,
        }));
    }
    handleDeleteNetwork() {
        this.dispatchEvent(new CustomEvent('delete-network', {
            detail: { selectedNetwork: this.selectedNetwork },
            bubbles: true,
            composed: true,
        }));
    }
    handleCreateNetwork() {
        this.dispatchEvent(new CustomEvent('create-network', {
            bubbles: true,
            composed: true,
        }));
    }
    render() {
        return html `
      <basic-card class="container">
        <div class="column">
          <select-input
            .options=${this.listNetworks.map((network) => ({
            value: network.network_id,
            label: network.name,
        }))}
            .value=${this.selectedNetwork?.network_id}
            .variant="primary"
            size="large"
            bold
            @select-change=${this.handleNetworkChange}
          ></select-input>
        </div>

        <div class="column">
          <div class="buttons">
            <div class="button" @click="${this.handleRenameNetwork}">
              <basic-icon name="edit" color="secondary" .label=${CommonActions.edit()}></basic-icon>
            </div>
            <div class="button" @click="${this.handleDuplicateNetwork}">
              <basic-icon name="copy" color="secondary" .label=${msg('Copy', { id: 'network.toolbox.copy', desc: 'Copy button alt' })}></basic-icon>
            </div>
            <div class="button" @click="${this.handleUpdateNetwork}">
              <basic-icon name="refresh" color="secondary" .label=${CommonActions.refresh()}></basic-icon>
            </div>
            <div class="button" @click="${this.handleExportNetwork}">
              <basic-icon name="export" color="secondary" .label=${CommonActions.export()}></basic-icon>
            </div>
            <div class="button" @click="${this.handleDeleteNetwork}">
              <basic-icon name="delete-copy" color="danger" .label=${CommonActions.delete()}></basic-icon>
            </div>
          </div>
        </div>

        <div class="column">
          <simple-button
            class="new-network"
            size="large"
            label=${msg('+ Network', { id: 'network.toolbox.addNetwork', desc: 'Add network button' })}
            variant="primary"
            special
            @button-click=${this.handleCreateNetwork}
          ></simple-button>
        </div>
      </basic-card>
    `;
    }
};
NetworkToolbox.styles = css `
    :host {
      display: flex;
      justify-content: center;
      font-family: inherit;
    }

    .container {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 10px 15px;
      width: 100%;
      gap: 15px; /* <-- ajoute de l'espace entre les colonnes */
    }

    /* La première colonne prend tout l'espace restant */
    .column:first-child {
      flex: 1;
      display: flex;
    }

    .column:not(:first-child) {
      display: flex;
      align-items: center;
    }

    select-input {
      width: 100%;
      flex: 1;
    }

    /* Boutons groupés */
    .buttons {
      display: flex;
      flex-direction: row;
    }

    .button {
      width: 45px;
      height: 45px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #ffffff;
      border: 1px solid #ccc;
      border-left: none;
      cursor: pointer;
      transition:
        background 0.3s,
        border-color 0.3s;
    }

    .button:first-child {
      border-left: 1px solid #ccc;
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
    }

    .button:last-child {
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
    }

    .button:hover {
      background: #f0f0f0;
      border-color: #aaa;
    }

    .button img {
      width: 22px;
      height: 22px;
    }
  `;
__decorate([
    property({ type: Object })
], NetworkToolbox.prototype, "listNetworks", void 0);
__decorate([
    property({ type: Object })
], NetworkToolbox.prototype, "selectedNetwork", void 0);
NetworkToolbox = __decorate([
    localized(),
    customElement('network-toolbox')
], NetworkToolbox);
export { NetworkToolbox };
//# sourceMappingURL=NetworkToolbox.js.map